<div class="container">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    @for (link of navLinks(); track link.path) { @if (!link.hide) {
    <a
      mat-tab-link
      [class.tab-error]="link.hasError"
      [routerLink]="link.path"
      routerLinkActive
      #rla="routerLinkActive"
      [active]="rla.isActive"
      [disabled]="link.disabled"
    >
      {{ link.label | translate }}
      @if (link.hasError) {
      <img src="images/notification2.svg" alt="error" class="tab-error-icon" />
      }
    </a>
    } }
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <ng-content></ng-content>
  </mat-tab-nav-panel>
</div>
